// 미디어 센터 카드 — 그리드용 PostCard 와 목록 첫 글용 HeroPost.
import { Link } from 'react-router-dom';
import { getAuthorAvatar } from '../../data/authorAvatars';
import styles from './MediaCenter.module.css';

/** 프로필 사진이 있으면 사진, 없으면 이니셜 원형으로 폴백한다. */
function Avatar({ author, size = 36 }) {
  const photo = getAuthorAvatar(author);

  if (photo) {
    return (
      <img
        className={styles.avatarPhoto}
        src={photo}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size }}
        loading="lazy"
        decoding="async"
      />
    );
  }

  return (
    <span
      className={styles.avatar}
      style={{ width: size, height: size, fontSize: size * 0.34 }}
      aria-hidden="true"
    >
      {author.initials}
    </span>
  );
}

export function PostCard({ post, sectionLabel }) {
  return (
    <article className={styles.card}>
      <div className={styles.cardThumb}>
        {post.thumbnailUrl ? (
          <img src={post.thumbnailUrl} alt={post.title} />
        ) : (
          <div className={styles.cardThumbFallback} aria-hidden="true">
            <span>{sectionLabel}</span>
          </div>
        )}
        <span className={styles.cardTag}>{sectionLabel}</span>
      </div>
      <h3 className={styles.cardTitle}>
        {/* stretched link — 카드 전체가 클릭되지만 접근성 트리에는 링크 하나만 남는다. */}
        <Link to={`/blog/${post.section}/${post.slug}`} className={styles.stretchedLink}>
          {post.title}
        </Link>
      </h3>
      <p className={styles.cardSummary}>{post.summary}</p>
      <div className={styles.cardFoot}>
        <span className={styles.cardAuthor}>{post.author.name}</span>
        <span className={styles.cardDate}>{post.publishedAt}</span>
      </div>
    </article>
  );
}

export function HeroPost({ post, sectionLabel }) {
  if (!post) return null;

  return (
    <article className={styles.hero}>
      <div className={styles.heroThumb}>
        {post.thumbnailUrl ? (
          <img src={post.thumbnailUrl} alt={post.title} />
        ) : (
          <div className={styles.heroThumbFallback} aria-hidden="true">
            <span>{sectionLabel}</span>
          </div>
        )}
      </div>
      <div className={styles.heroBody}>
        <div className={styles.heroMeta}>
          <span className={styles.heroTag}>
            {post.featured ? 'Featured · ' : ''}
            {sectionLabel}
          </span>
          <span className={styles.mono}>{post.publishedAt}</span>
        </div>
        <h2 className={styles.heroTitle}>
          <Link to={`/blog/${post.section}/${post.slug}`} className={styles.stretchedLink}>
            {post.title}
          </Link>
        </h2>
        <p className={styles.heroSummary}>{post.summary}</p>
        <div className={styles.heroAuthor}>
          <Avatar author={post.author} size={38} />
          <div>
            <div className={styles.heroAuthorName}>{post.author.name}</div>
            <div className={styles.heroAuthorRole}>
              {post.author.role} · {post.readMinutes}분 분량
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
